import { format, subDays } from 'date-fns';

/** Turns a sparse {date,count}[] response into a dense, chronologically-ordered array of `days` counts. */
export function buildDailySeries(
    data: { date: string; count: number }[] | undefined,
    days: number
): number[] {
    const map = new Map<string, number>();
    (data || []).forEach((d) => map.set(format(new Date(d.date), 'yyyy-MM-dd'), d.count));
    return Array.from({ length: days }, (_, i) => {
        const key = format(subDays(new Date(), days - 1 - i), 'yyyy-MM-dd');
        return map.get(key) || 0;
    });
}

/** Human-readable day labels for the same chronological range buildDailySeries produces. */
export function buildDayLabels(days: number): string[] {
    return Array.from({ length: days }, (_, i) =>
        format(subDays(new Date(), days - 1 - i), 'EEE, MMM d')
    );
}

/** Compares the most recent half of a chronological series against the half before it. */
export function weekOverWeekLabel(series: number[]): string | undefined {
    const half = Math.floor(series.length / 2);
    const recent = series.slice(series.length - half).reduce((a, b) => a + b, 0);
    const previous = series.slice(0, series.length - half).reduce((a, b) => a + b, 0);

    if (recent === 0 && previous === 0) return undefined;
    if (previous === 0) return 'New this week';

    const pctChange = Math.round(((recent - previous) / previous) * 100);
    if (pctChange === 0) return 'Flat vs last week';
    return `${pctChange > 0 ? '+' : ''}${pctChange}% vs last week`;
}
